import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IStockItemDto, IStockItemDtosQueryParams } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IStockItemDto>, IStockItemDtosQueryParams>>(undefined as any);
